// ============================================================
//  Hinweise zu kontraintuitiven Regeln (Paket „Regeln aktiv erklären").
//  Das Regelwerk ist SAPs, nicht unseres — und es enthält Einstufungen,
//  die niemand rät. Die werden nicht kommentarlos gezeigt, sondern erklärt,
//  damit der Einwand im Termin beantwortet ist, bevor er kommt.
// ============================================================
import { rulesForObject } from "../data/pce-ruleset";
import { CLASS_LABEL } from "./rules";
import type { AuthValue, LicenseClass } from "./types";

/** Handverlesene Erklärungen zu einzelnen Werten. Zeilenangaben beziehen sich auf PCE_RISE_V1.70.XLSX. */
const SPEZIFISCH: Record<string, string> = {
  "F_BKPF_BUK|ACTVT|06":
    "Kontraintuitiv, aber so im Regelwerk (V1.70, Zeile 599): Löschen (06) ist Core — Anlegen und Ändern (01/02) sind nur Self-Service. Bei diesem Objekt geht es um den Buchungskreis-Rahmen, die eigentliche Buchungsberechtigung hängt an anderen Objekten.",
  "F_BKPF_BUK|ACTVT|22":
    "Zeile 89 im Regelwerk: ACTVT 22 (Ändern per Massenpflege) ist Advanced, obwohl 02 (Ändern) nur Self-Service ist. Der Wert entscheidet, nicht das Objekt.",
  "F_BKPF_BLA|ACTVT|22":
    "Belegart-Objekt: ACTVT 22 liegt auf Advanced, 01 auf Core, 03 auf Self-Service — dasselbe Objekt in drei Klassen.",
  "S_WFFLXDEF|ACTVT|06":
    "Workflow-Definition löschen (06) ist Advanced — Anzeige (03) nur Self-Service. Externe brauchen typischerweise keines von beidem außer dem Auslösen.",
};

/** Wie viele Klassen ein Objekt im Regelwerk abdeckt — und welche. */
export function classesOfObject(obj: string): LicenseClass[] {
  const set = new Set<LicenseClass>();
  for (const r of rulesForObject(obj)) if (r.cls) set.add(r.cls);
  return [...set];
}

/**
 * Erklärung zu einem Berechtigungswert, falls es etwas zu erklären gibt.
 * Spezifische Hinweise haben Vorrang; sonst der generische, wenn das Objekt
 * in mehreren Klassen vorkommt (das ist die Kernmechanik der Klassifikation).
 */
export function ruleHint(av: AuthValue): string | null {
  const key = `${av.obj}|${av.field ?? ""}|${av.val ?? ""}`;
  if (SPEZIFISCH[key]) return SPEZIFISCH[key];
  const cls = classesOfObject(av.obj);
  if (cls.length >= 2) {
    return `${av.obj} liegt je nach Wert in ${cls.length} Klassen (${cls.map((c) => CLASS_LABEL[c]).join(", ")}) — der Wert entscheidet, nicht das Objekt.`;
  }
  return null;
}
